import React, { useEffect, useState } from "react";
import Header from "../../layout/Header";
import Footer from "../../layout/Footer";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { decryptFromStoreLoc } from "../../helper/localStore";
import { useTranslation } from "react-i18next";
import "../../i18n"; // important to import

function BusinessUserSupportPlans() {
  const { t } = useTranslation("BusinessUserSupportPlans");
  const location = useLocation();
  const navigate = useNavigate();
  const [user, setUser] = useState({});
  const plans = [
    {
      title: t("pay_as_you_go_title"),
      price: "€ 0",
      amount: 0,
      details: [
        t("pay_as_you_go_details_1"),
        t("pay_as_you_go_details_2"),
        t("pay_as_you_go_details_3"),
        t("pay_as_you_go_details_4"),
      ],
    },
    {
      title: t("basic_email_title"),
      price: "€ 1,000",
      amount: 1000,
      details: [
        t("basic_email_details_1"),
        t("basic_email_details_2"),
        t("basic_email_details_3"),
      ],
    },
    {
      title: t("premium_title"),
      price: "€ 10,000",
      amount: 10000,
      details: [
        t("premium_details_1"),
        t("premium_details_2"),
        t("premium_details_3"),
        t("premium_details_4"),
        t("premium_details_5"),
      ],
    },
  ];

  useEffect(() => {
    const decryptedInfoResult = decryptFromStoreLoc("user");
    setUser(decryptedInfoResult);
  }, []);

  const handleNavigate = (plan, amount) => {
    if (user?.role === 12) {
      navigate("/business-shared-courses", {
        state: {
          name: location?.state?.name,
          plan: location?.state?.plan,
          userPlan: location?.state?.userPlan,
          courseTrails: location?.state?.courseTrails,
          supportPlan: {
            supportPlanName: plan,
            supportPlanAmount: amount,
          },
        },
      });
    }
  };

  return (
    <>
      <Header />
      <section className="payment-flow-section">
        <div className="container">
          <h3 className="welcome-title max-width-100">
            {t("selectasupportpricingplan")}
          </h3>
          <p className="welcome-description plan-description">
            {t("selectfits")}
          </p>
          <div className="row plans-card support-pricing-plan g-4">
            {plans.map((plan, index) => (
              <div className="col-md-6 col-lg-6 col-xl-4" key={index}>
                <div className="card border-0 h-100">
                  <div className="card-header bg-transparent border-0 p-0">
                    <h3 className="max-width-100">{plan.title}</h3>
                    <h2 className="mb-0">{plan.price}</h2>
                    <p className="employee h-auto">{t("permonth")}</p>
                  </div>
                  <div className="card-body p-0">
                    <div className="d-flex justify-content-center align-items-center m-auto">
                      <ul className="plan-details-list">
                        {plan.details.map((detail, idx) => (
                          <li key={idx}>
                            <img src="/admin/check.png" alt="" />
                            {detail}
                          </li>
                        ))}
                      </ul>
                    </div>
                  </div>
                  <div className="card-footer bg-transparent border-0 p-0 d-flex justify-content-center">
                    <button
                      className="w-auto text-decoration-none"
                      onClick={() => handleNavigate(plan.title, plan.amount)}
                    >
                      {t("getstarted")}
                    </button>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>
      <Footer />
    </>
  );
}

export default BusinessUserSupportPlans;
